import React from 'react';
import PropTypes from 'prop-types';

import environment from 'src/app/environment';


const Logo = ({ width }) => (
  <a href={ environment.mainPage }
     title="Przejdź do strony głównej serwisu"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMinYMax meet"
      viewBox="0 0 179.58376 53.333126"
      width={ width }
    >
      <defs>
        <clipPath id="a">
          <path
            d="M19.159 38.46c-8.117 0-16.809-6.972-16.809-17.351 0-9.566 7.539-17.348 16.809-17.348h105.103c9.247
            0 16.772 7.782 16.772 17.348 0 10.379-8.673 17.351-16.772 17.351H19.159z"/>
        </clipPath>
        <linearGradient x2="1" id="b" gradientUnits="userSpaceOnUse"
                        gradientTransform="matrix(138.68359 0 0 -138.68359 2.35 21.11)">
          <stop offset="0" stopColor="#1c75bc"/>
          <stop offset="1" stopColor="#262262"/>
        </linearGradient>
        <clipPath id="c">
          <path d="M0 42.667h143.667V0H0v42.667z"/>
        </clipPath>
      </defs>
      <g clipPath="url(#a)" transform="matrix(1.25 0 0 -1.25 0 53.333)">
        <path
          d="M19.159 38.46c-8.117 0-16.809-6.972-16.809-17.351 0-9.566 7.539-17.348 16.809-17.348h105.103c9.247 0
          16.772 7.782 16.772 17.348 0 10.379-8.673 17.351-16.772 17.351H19.159z"
          fill="url(#b)"/>
      </g>
      <g clipPath="url(#c)" transform="matrix(1.25 0 0 -1.25 0 53.333)">
        <path
          d="M23.52 26.142c-3.373 0-4.674-2.516-4.674-5.006 0-2.617 1.36-5.03 4.822-5.03 3.432 0 4.585 2.54
          4.585 5.134 0 2.489-1.478 4.902-4.733 4.902m-7.1 1.617h2.515v-1.797h.06c.828 1.463 2.78 2.105 4.88 2.105
          4.705 0 7.041-3.234 7.041-6.983 0-3.747-2.307-6.904-6.982-6.904-1.568 0-3.816.514-4.94
          2.079h-.059V9.406H16.42v18.353zM33.79 27.759h2.366v-2.8h.06c1.212 2.132 2.898 3.185 5.62 3.108v-2.31c-4.053
          0-5.532-2.003-5.532-5.365v-5.904H33.79v13.27zM53.198
          21.342c-.977-.616-2.87-.643-4.556-.898-1.657-.257-3.077-.771-3.077-2.388
          0-1.437 1.42-1.95 2.958-1.95 3.315 0 4.675 1.797 4.675
          3.003v2.233zm4.083-6.803c-.443-.23-1.006-.36-1.805-.36-1.302 0-2.13.616-2.13
          2.055-1.39-1.413-3.254-2.054-5.385-2.054-2.78 0-5.059 1.078-5.059 3.723 0 3.002 2.574 3.644
          5.178 4.08 2.781.463 5.148.308 5.148 1.95 0 1.9-1.805 2.209-3.403
          2.209-2.13 0-3.698-.566-3.817-2.516h-2.514c.148 3.285 3.077 4.44 6.48 4.44 2.75 0 5.74-.537
          5.74-3.645v-6.827c0-1.027 0-1.488.797-1.488.208 0 .444.025.77.128v-1.695zM70.004 23.497c-.384
          1.67-1.716 2.645-3.785 2.645-3.641 0-4.765-2.49-4.765-5.186 0-2.438 1.273-4.85 4.468-4.85 2.426 0 3.875
          1.231 4.2 3.234h2.575c-.563-3.235-2.9-5.16-6.746-5.16-4.674 0-7.16 2.824-7.16 6.776 0 3.98 2.367
          7.11 7.22 7.11 3.46 0 6.243-1.41 6.597-4.569h-2.604zM88.17
          14.488h-2.366v2.104h-.06c-1.061-1.642-2.778-2.413-4.97-2.413-4.022 0-5.264 2.002-5.264
          4.852v8.728h2.515v-8.985c0-1.616 1.182-2.669 3.106-2.669 3.048 0 4.526 1.771 4.526
          4.158v7.496h2.514V14.49zM94.624
          30.146h-2.516v2.669h2.516v-2.669zm0-17.353c0-2.36-1.45-3.388-3.669-3.388-.414
          0-.857.026-1.302.103v1.874c.355-.051.68-.051 1.036-.051 1.093 0 1.419.461 1.419
          1.822v14.606h2.516V12.793zM99.091 17.337h3.283v-2.849h-3.283v2.849zM113.945
          26.142c-3.374 0-4.676-2.516-4.676-5.006 0-2.617 1.362-5.03 4.824-5.03 3.431 0 4.585 2.54 4.585 5.134 0
          2.489-1.479 4.902-4.733 4.902m-7.102 1.617h2.514v-1.797h.06c.828 1.463 2.782 2.105 4.882 2.105 4.704 0
          7.042-3.234 7.042-6.983 0-3.747-2.309-6.904-6.983-6.904-1.567 0-3.816.514-4.94
           2.079h-.06V9.406h-2.515v18.353zM124.449 32.815h2.516V14.488h-2.516v18.327z"
          fill="#fff"/>
      </g>
    </svg>
  </a>
);

Logo.propTypes = {
  width: PropTypes.number
};

Logo.defaultProps = {
  width: 160
};

export default Logo;
